import * as React from 'react';
import { UIState } from 'data/UIState';
import { observer } from 'mobx-react';
import Dropzone from 'react-dropzone';

import './JournalSubPage.pcss';
import { IJournalEntry, JournalData, MOOD_LIST, ENTRY_SOURCE, JournalLine } from 'data/JournalData';
import { IconButton } from 'components/widgets/IconButton';
import { observable, computed } from 'mobx';
import { Button } from 'components/widgets/Button';
import * as moment from 'moment';
import {Waypoint} from 'react-waypoint';
import { BubbleWrapper } from 'components/widgets/BubbleWrapper';
import { ITrackersWeekSummary, ITrackerWeek } from 'data/TrackersData';
import { Icon } from 'components/widgets/icons';
import {Alert} from "../../data/Alert";

@observer
export class JournalSubPage extends React.Component {

  @observable showMoreBubbles:boolean = false;

  handleWaypointEnter = () => {
		if(!JournalData.noMoreJournalEntries && !JournalData.loading) {
			this.showMoreBubbles = true;
			// wait 1/4 of a second before dispatching the request
			setTimeout(()=> {
        JournalData.loadMore()
        .then(()=>{
        })
        .catch((err)=>{
          
        })
        .then(()=>{
					this.showMoreBubbles = false;
        });
			}, 250);
		}
	}

	handleWaypointLeave = () => {
		// nothing to do here
	}

  @computed
  get zeroState() {
    return JournalData.loaded && JournalData.journalEntries.length==0;
  }

  render() {



    return !UIState.isJournal ? null : ( 
      <div className="journal">
        <AddJournalEntry />
        {this.zeroState ?
        <div className="zero">          
          <div className="item">
            <img src="/res_sys/hand.png" />
            <p>Hi there! This is your wellness journal. Use it as often as you like throughout the program.</p>
          </div>
          <div className="item">
            <img src="/res_sys/write.png" />
            <p>Post your thoughts or add a picture of your meals (feel free to add calories info, etc.). You can always delete any post.</p>
          </div>
          <div className="item">
            <img src="/res_sys/lock.png" />
            <p>“My Wellness” is just for you, nothing you post in your journal is ever visible to other users. 
              {/* You can choose to privately share “My Wellness” with a practioner you are working with. */}
            </p>
          </div>
        </div>
        :
        <React.Fragment>
          <JournalLines />      
          <Waypoint onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave} />
          <BubbleWrapper show={this.showMoreBubbles} />          
        </React.Fragment>
        }
      </div>
    );
  }
}


@observer
class JournalLines extends React.Component {

  render() {                 
    let thisWeek = moment().startOf('week');
    let week:moment.Moment|null = null; 
    return (
      <React.Fragment>
        {JournalData.journalLines.map((journalLine, idx)=>{

          const lineWeek = journalLine.trackersSummary ? moment(journalLine.trackersSummary.startDay) : moment(journalLine.createdDate).startOf('week');
          let header:string|null = "This Week";
          if(week==null && lineWeek.isSame(thisWeek)) {
            week = moment(lineWeek);
          } else if(null!=week && lineWeek.isBefore(week)) {
            week = moment(lineWeek);
            header = week.format('MMM D')+'–';
            const eow = moment(week).add(6, 'day');
            if(eow.month()===week.month()) {
              header+=eow.format('D')
            } else {
              header+=eow.format('MMM D')
            }
          } else {
            header = null;
          }

          if(journalLine.entry) {
            return (
              <React.Fragment key={journalLine.entry._id}>
                {header && <Headline header={header} /> }
                <JournalEntry journalEntry={journalLine.entry} />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={idx}>
                {header && <Headline header={header} /> }
                <JournalEntryTrackers journalLine={journalLine} />
              </React.Fragment>
            );
          }
        })}
      </React.Fragment>
    );    
  }
}

const Headline = (props:{header:string}) => 
  <div className="journalHeadline">
    {props.header}
  </div>
;

@observer
class JournalEntryTrackers extends React.Component<{journalLine:JournalLine}> {
  render() {
    const summary:ITrackersWeekSummary = this.props.journalLine.trackersSummary;
    const day = moment(summary.startDay);
    return (
      <div className="journalEntry">
        <table>
          <thead>
            <tr>
              <th>Trackers</th>
              <th>SUN<br/>{day.format('M/D')}</th>
              <th>MON<br/>{day.add(1, 'day').format('M/D')}</th>
              <th>TUE<br/>{day.add(1, 'day').format('M/D')}</th>
              <th>WED<br/>{day.add(1, 'day').format('M/D')}</th>
              <th>THU<br/>{day.add(1, 'day').format('M/D')}</th>
              <th>FRI<br/>{day.add(1, 'day').format('M/D')}</th>
              <th>SAT<br/>{day.add(1, 'day').format('M/D')}</th>
            </tr>
          </thead>
          <tbody>
            {summary.trackerWeeks.map((ts:ITrackerWeek, idx)=><tr key={idx}>
              <td>
                <Icon iconName={ts.tracker.iconName} color="#7d83b3" />
                {ts.tracker.name}
              </td>
              {ts.dayVals.map((day, idx2)=><td key={idx2}>{day}</td>)}
            </tr>)}
          </tbody>
        </table>
      </div>
    )
  }
}


@observer
class AddJournalEntry extends React.Component {
  @observable activated:boolean;
  @observable image:any|null = null;
  @observable saving:boolean = false;
  @observable mood:string = '';
  @observable text:string = '';
  
  handleDrop = (dropped) => {
    this.activated = true;
    this.image = dropped[0];
  }

  componentWillUnmount() {
    this.clearImage();
  }

  // Make sure to revoke the data uris to avoid memory leaks
  clearImage = () => {
    if(this.image && this.image.preview) {
      URL.revokeObjectURL(this.image.preview);
    }
  }

  save = () => {
    if(!this.saving) {
      this.saving = true;
      JournalData.createJournalEntry(this.text, this.mood, this.image)
      .then(()=>{
        this.cancel();
      })
      .catch(()=>{
        Alert.alert('Failed to save your journal entry. Please make sure that your Internet connection is stable and try again.');
      })
      .then(()=>{
        this.saving = false;
      });
    }
  }

  activate = () => {
    this.activated = true;
  }
  
  cancel = () => {
    this.activated = false;
    this.clearImage();
    this.image = null;
    this.mood = '';
    this.text = '';
  }

  render() {
      const imageState = this.image!=null;
      let dropzoneRef;

      return (
        <Dropzone className={`addJournalEntry${this.activated?' activated':''}`}  ref={(node) => { dropzoneRef = node; }} onDrop={this.handleDrop}  disableClick>
          <div className="centerBox">
            <i className="material-icons write" onClick={this.activate}>edit</i>
            <textarea value={this.text} onFocus={this.activate} placeholder="add a photo or post your thoughts…" onChange={(e)=>{ this.text=e.target.value; }} />
            {this.activated && <div className="controls">
              <Button className="submit" disabled={this.saving} onClick={this.save}>POST</Button>

              {imageState ? 
                <img className="photo"  onClick={()=>{ dropzoneRef.open(); }} src={this.image?this.image.preview:''} /> 
              : 
                <IconButton className="photo" onClick={()=>{ dropzoneRef.open(); }}>photo_camera</IconButton> 
              }

              <div className="moodSelector">
                <span>Mood:</span>
                {MOOD_LIST.map(mood=><i key={mood} className={`material-icons${this.mood===mood?' selected':''}`} onClick={()=>{ this.mood = mood; }}>{mood}</i>)}
              </div>
              <Button className="cancel" flat cancel disabled={this.saving} onClick={this.cancel}>CANCEL</Button>
            </div> 
            }
          </div>
        </Dropzone>
      );


    {/* } else {
      return (
        <div className="addJournalEntry">
          <div className="fauxJournalInput" onClick={()=>{ this.activated = true; }}> 
            <i className="material-icons write">edit</i>
            add a photo or post your thoughts…
          </div>
        </div>
      );
    } */}
    
  }
}






@observer
class JournalEntry extends React.Component<{journalEntry:IJournalEntry}> {

  @observable deleting:boolean = false;

  onClickDelete = () => {
    this.deleting = true;
    JournalData.deleteJournalEntry(this.props.journalEntry)
    .catch(()=>{
      Alert.alert('Failed to delete. Please make sure that your Internet connection is stable and try again.');
      this.deleting = false;
    });
  }

  render() {
    const { journalEntry } = this.props;
    return (
      <div className="journalEntry">
        <div className="meta">
          <div className="date">{moment(journalEntry.createdDate).format('M/D')}</div>
          {journalEntry.mood && <div className="mood"><i className="material-icons">{journalEntry.mood}</i></div> }
        </div>
        <div className="guts">
          {journalEntry.source===ENTRY_SOURCE.JOURNAL && <EntryJournalSource text={journalEntry.text} photo={journalEntry.photo} /> }
          {journalEntry.source===ENTRY_SOURCE.LONG_TERM_GOAL && <EntryLongTermGoal text={journalEntry.text} /> }
          {journalEntry.source===ENTRY_SOURCE.SHORT_TERM_GOAL && <EntryShortTermGoal text={journalEntry.text} /> }
        </div>
        <div className="actions">
          <div className="delete"><IconButton disabled={this.deleting} onClick={this.onClickDelete}>delete</IconButton></div>        
        </div>
      </div>
    )
  }
}

const EntryJournalSource = (props:{text:string, photo:string}) => 
  <React.Fragment>  
    {props.text && <div className="text">{props.text}</div> }
    {props.photo && <div className="photo">
      <img src={`/usercontent/${props.photo}`} />
    </div>}
  </React.Fragment>  
;

const EntryLongTermGoal = (props:{text:string}) => 
  <div className="goal">  
    <i className="material-icons">check_box</i>
    <h2>Long term goal met!</h2>
    <p>{props.text}</p>
  </div>
;

const EntryShortTermGoal = (props:{text:string}) => 
  <div className="goal">  
    <i className="material-icons">check_box</i>
    <h2>Short term goal met!</h2>
    <p>{props.text}</p>
  </div>
;
